import { BooleanInput, Create, CreateContextProvider, DateTimeInput, Form, required, SaveButton, SelectInput, TextInput, Toolbar, TopToolbar, useCreateController, useNotify, useRecordContext, useRedirect, useTranslate } from 'react-admin';
import { Box, Card, Divider, Stack, Typography, Button as MUIButton, Tooltip, IconButton } from '@mui/material';

import { useEffect, useRef, useState } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';
import { chains } from 'src/assets/data';

interface FormProps {
    isCreate: boolean;
}
const SearchPlaceholderForm = (props: FormProps) => {
    const { isCreate } = props;
    const t = useTranslate();
    const redirect = useRedirect();
    const { watch, setValue, trigger } = useFormContext();
    const record = useRecordContext();
    const placeholder = watch('placeholder') || record?.placeholder || "";
    const [addressMessage, setAddressMessage] = useState("")
    
    useEffect(() => {
        if (placeholder && typeof placeholder === 'object' && !Array.isArray(placeholder)) {
            setValue('placeholder', JSON.stringify(placeholder, null, 2));
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [placeholder]);

    return (
        <>
            <Stack spacing={3} gap={2}>


                <Stack direction={{ xs: 'column', sm: 'row' }} alignItems={{ xs: 'stretch', sm: 'center' }} spacing={2} mb={1}>
                    <Box sx={{ flexBasis: '20%', flexShrink: 0, mt: -1 }}>
                        <Typography variant="body2">{t("module.searchPlaceholder.placeholder")}</Typography>
                    </Box>
                    <Box sx={{ flexGrow: 1 }}>
                        <TextInput
                            source="placeholder"
                            label=""
                            placeholder={t("module.searchPlaceholder.placeholder")}
                            fullWidth
                            multiline
                            validate={[required()]}
                            helperText={<span style={{ color: 'red' }}></span>}
                            rows={4}
                        />
                    </Box>
                </Stack>

                <Stack direction={{ xs: 'column', sm: 'row' }} alignItems={{ xs: 'stretch', sm: 'center' }} spacing={2} mb={1}>
                    <Typography
                        variant="body2"
                        sx={{ flexBasis: '20%', flexShrink: 0 }}
                    >
                        {t("module.searchPlaceholder.contractAddress")}
                    </Typography>
                    <Box sx={{ flexGrow: 1 }}>
                        <TextInput
                            source="contractAddress"
                            label=""
                            placeholder={t("module.searchPlaceholder.contractAddress")}
                            disabled={!isCreate}
                            fullWidth
                            helperText={<span style={{ color: 'red' }}>{addressMessage}</span>}
                            
                        />
                    </Box>
                </Stack>
                <Stack direction={'row'} alignItems={'center'} spacing={2} mb={1}>
                    <Typography
                        variant="body2"
                        sx={{ flexBasis: '20%', flexShrink: 0 }}
                    >
                        {t("module.searchPlaceholder.enable")}
                    </Typography>
                    <Box
                        sx={{ flexGrow: 1 }}
                    >
                        <BooleanInput label='' source="enable" helperText={<span style={{ color: 'red' }}></span>} />
                    </Box>

                </Stack>
            </Stack>
            </>
    );
};

export default SearchPlaceholderForm;
